import PageWrapper from 'components/page/PageWrapper';
import {useTranslation} from 'react-i18next';
import { useNavigate } from 'react-router';
import { useState, useEffect } from 'react';
import { Link } from 'react-router';
import List from 'components/board/List';

import bg from 'assets/images/banner/banner01.jpg';
import Button from 'components/button/Button';

export default function Certifications(){
  const {t} = useTranslation();
  const navigate = useNavigate();
  const menuName= t('menu.sub-certification');
  const path=[{url:'/corporation', name:t('menu.main-about')}, {url:'/corporation/certifications', name:menuName}];
  const title = t('certifications.banner.title')
  const comment = t('certifications.banner.comment')

  const [login, setLogin] = useState(false);
  useEffect(()=>{
    console.log(localStorage.getItem('token'))
    if(localStorage.getItem('token')) setLogin(true);
    else setLogin(false);
  }, [login])

  const handleNavigate = ()=>{
    navigate('/corporation/certifications/editor');
  }

  const handleLogout = () => {
    localStorage.removeItem('token');
    setLogin(false);
  }

  return (
    <PageWrapper 
      bg={bg} 
      menuName={menuName}
      title={title}
      comment={comment}
      path={path}>
      <div className="flex justify-center">
        <div className="flex flex-col lg:w-[1200px]">
          {login?
          <div className="pr-6 text-end">
              <Button handler={handleNavigate} className="mr-2">글쓰기</Button>
              <Button handler={handleLogout}>로그아웃</Button>
          </div>
          :null}
          <List type="certifications" viewUrl={`/corporation/certifications`}/>
        </div>
      </div>
    </PageWrapper>
  );
}